import '@backstage/cli/asset-types';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@backstage/canon/css/styles.css';
import './styles/pichinchaStyles.css';
import './styles/customHeader.css';
import './styles/templateCardCustom.css';
import './styles/homeHeaderFix.css';

ReactDOM.createRoot(document.getElementById('root')!).render(<App />);
